import { useEffect } from "react";
import { FormProvider, useWatch, type UseFormReturn } from "react-hook-form";
import type { ProductFormValues } from "../types";
import ProductBasicInfo from "./product-basic-info";
import ProductImages from "./product-images";
import ProductKeywords from "./product-keywords";

type Props = {
  methods: UseFormReturn<ProductFormValues>;
  onSubmit: (values: ProductFormValues, event?: React.BaseSyntheticEvent) => Promise<void>;
  onValuesChange: (values: ProductFormValues) => void;
  onCategoriesLoadingChange?: (loading: boolean) => void;
};

function PreviewSync({ onChange }: { onChange: (values: ProductFormValues) => void }) {
  const values = useWatch<ProductFormValues>();
  useEffect(() => onChange(values as ProductFormValues), [onChange, values]);
  return null;
}

export default function ProductForm({ methods, onSubmit, onValuesChange, onCategoriesLoadingChange }: Props) {
  return (
    <FormProvider {...methods}>
      <PreviewSync onChange={onValuesChange} />
      <form id="product-form" className="flex! flex-col! gap-8!" onSubmit={methods.handleSubmit(onSubmit)}>
        <ProductBasicInfo onLoadingChange={onCategoriesLoadingChange} />
        <ProductImages />
        <ProductKeywords />
      </form>
    </FormProvider>
  );
}
